import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X, Instagram, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { contactData } from '../data/mock';

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const translations = {
    en: {
      menu: 'Menu',
      contact: 'Contact',
      location: 'Location'
    },
    fr: {
      menu: 'Menu',
      contact: 'Contact',
      location: 'Localisation'
    }
  };

  const t = translations[language];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a1929]/95 backdrop-blur-md border-b border-[#c9a961]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/krpy34tr_Final_Logo_Sids_Deli-removebg-preview.png" 
              alt="Sid's Deli" 
              className="h-14 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('menu')} 
              className="text-[#c9a961] hover:text-[#d4b975] transition-colors font-medium"
            >
              {t.menu}
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="text-[#c9a961] hover:text-[#d4b975] transition-colors font-medium"
            >
              {t.contact}
            </button>
            <button 
              onClick={() => scrollToSection('location')} 
              className="text-[#c9a961] hover:text-[#d4b975] transition-colors font-medium"
            >
              {t.location}
            </button>
            
            {/* Language Toggle */}
            <Button
              onClick={toggleLanguage}
              variant="outline"
              className="border-[#c9a961] text-[#c9a961] hover:bg-[#c9a961] hover:text-[#0a1929] transition-all"
            >
              {language === 'en' ? 'FR' : 'EN'}
            </Button>

            {/* Social Links */}
            <a 
              href={`https://instagram.com/${contactData.instagram}`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#c9a961] hover:text-[#d4b975] transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-4">
            <Button
              onClick={toggleLanguage}
              variant="outline"
              size="sm"
              className="border-[#c9a961] text-[#c9a961] hover:bg-[#c9a961] hover:text-[#0a1929]"
            >
              {language === 'en' ? 'FR' : 'EN'}
            </Button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#c9a961] hover:text-[#d4b975] transition-colors"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-6 space-y-4">
            <button 
              onClick={() => scrollToSection('menu')} 
              className="block w-full text-left text-[#c9a961] hover:text-[#d4b975] transition-colors font-medium py-2"
            >
              {t.menu}
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="block w-full text-left text-[#c9a961] hover:text-[#d4b975] transition-colors font-medium py-2"
            >
              {t.contact}
            </button>
            <button 
              onClick={() => scrollToSection('location')} 
              className="block w-full text-left text-[#c9a961] hover:text-[#d4b975] transition-colors font-medium py-2"
            >
              {t.location}
            </button>
            <a 
              href={`https://instagram.com/${contactData.instagram}`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-[#c9a961] hover:text-[#d4b975] transition-colors py-2"
            >
              <Instagram className="w-5 h-5" />
              <span>@{contactData.instagram}</span>
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;